import { PrimaryButton } from '../../buttons/primary/primary-button';
import { SecondaryButton } from '../../buttons/secondary/secondary-button';
import { Text } from '../../text/text.component';
import { WeekViewDatePickerActionBarProps } from '../types';
import { useWeekViewDatePicker } from '../week-view-date-picker.provider';

export const Actions = ({
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  enterTimeWarningLabel = 'Enter Time',
  onCancel,
  onConfirm,
}: WeekViewDatePickerActionBarProps) => {
  const { activeValue, hasTimeInput, initialValue, onChange } = useWeekViewDatePicker();
  const disabled = hasTimeInput && (!activeValue.endTime || !activeValue.startTime);

  const handleCancel = () => {
    onChange(initialValue, true);
    onCancel?.();
  };

  const handleConfirm = () => {
    onConfirm?.(activeValue);
  };

  return (
    <div className='action-bar'>
      {disabled && <Text>{enterTimeWarningLabel}</Text>}
      {typeof onCancel !== 'undefined' && <SecondaryButton onClick={handleCancel}>{cancelLabel}</SecondaryButton>}
      {typeof onConfirm !== 'undefined' && (
        <PrimaryButton disabled={disabled} onClick={handleConfirm}>
          {confirmLabel}
        </PrimaryButton>
      )}
    </div>
  );
};
